import * as types from "./actionType";
import * as services from "./service";
import * as typesAdesao from "../../Pages/Adesao/actionType";
import * as typesRotina from "../../Pages/Rotina/actionType";
import { sendErrorMsg } from "Misc/utils";

const onlyDigits = (value) => (value || "").toString().replace(/\D/g, "");

const toNumber = (value) => {
  if (value === "" || value === undefined || value === null) {
    return null;
  }

  const parsed = Number(String(value).replace(",", "."));
  return Number.isNaN(parsed) ? null : parsed;
};

const normalizeAltura = (altura) => {
  const parsed = toNumber(altura);
  if (parsed === null) {
    return null;
  }

  // The UI collects altura in centimeters (e.g., 162), while the API expects meters (e.g., 1.62).
  if (parsed > 3) {
    return Number((parsed / 100).toFixed(2));
  }

  return parsed;
};

export const getInfo = pacienteID => async dispatch => {
  try {
    dispatch({ type: types.FETCHING_INFO });
    const response = await services.getInfo(pacienteID);
    dispatch({
      type: types.FETCHING_INFO_COMPLETE,
      payload: response
    });
  } catch (error) {
    dispatch({ type: types.FETCHING_INFO_ERROR });
    sendErrorMsg(error);
  }
};

export const getFotoPaciente = pacienteID => async dispatch => {
  try {
    dispatch({ type: types.FETCHING_PHOTO });
    const response = await services.getFotoPaciente(pacienteID);
    dispatch({
      type: types.FETCHING_PHOTO_COMPLETE,
      payload: response
    });
  } catch (error) {
    dispatch({ type: types.FETCHING_PHOTO_ERROR });
  }
};

export const editInfo = paciente => async dispatch => {
  const newPacienteInfo = paciente;

  dispatch({ type: types.EDITED_INFO, payload: newPacienteInfo });
};

export const atualizarInfoPessoal = (
  paciente,
  pacienteID,
  tarefa,
  step,
  tipo
) => async (dispatch, getState) => {
  try {
    const infoAtual = getState().informacaopessoal || {};
    const enderecoAtual = infoAtual.endereco || {};

    const infoAtualFlat = {
      ...infoAtual,
      cep: enderecoAtual.cep,
      logradouro: enderecoAtual.logradouro,
      cidade: enderecoAtual.cidade,
      uf: enderecoAtual.uf,
      complemento: enderecoAtual.complemento,
      bairro: enderecoAtual.bairro,
      numero: enderecoAtual.numero
    };

    const pacienteMerged = {
      ...infoAtualFlat,
      ...(paciente || {})
    };

    const {
      ncto,
      cep,
      uf,
      bairro,
      cidade,
      numero,
      complemento,
      logradouro,
      endereco: _endereco,
      ...rest
    } = pacienteMerged;

    const newPacienteInfo = {
      ncto: ncto,
      endereco: {
        cep: cep,
        logradouro: logradouro,
        cidade: cidade,
        uf: uf,
        complemento: complemento,
        bairro: bairro,
        numero: numero
      },
      ...rest
    };

    const dto = {
      paciente: String(pacienteID),
      cpf: onlyDigits(rest.cpf),
      nome: rest.nome,
      ncto: ncto,
      tech: rest.tech,
      sexo: rest.sexo,
      telefone: onlyDigits(rest.telefone),
      telefoneOpcional: onlyDigits(rest.telefoneOpcional),
      email: rest.email,
      peso: toNumber(rest.peso),
      altura: normalizeAltura(rest.altura),
      sozinho: rest.sozinho,
      idosoFezCadastro: rest.idosoFezCadastro,
      grauParentesco: rest.grauParentesco,
      endereco: {
        cep: onlyDigits(cep),
        logradouro: logradouro,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        uf: uf,
        complemento: complemento
      }
    };


    const response = await services.attInfoPessoal(tarefa, dto);
    let newStep = step + 1;
    if (step === 6) {
      newStep = step;
    }

    await dispatch({ type: types.UPDATE_INFO, payload: newPacienteInfo });

    await dispatch({
      type: typesAdesao.CHANGE_PACIENTE,
      payload: response.paciente
    });
    await dispatch({ type: typesAdesao.CHANGE_STEP, payload: newStep });

    dispatch({
      type: typesRotina.MODIFY_FIELDS,
      payload: { infoPessoal: false }
    });
  } catch (error) {
    dispatch({ type: types.UPDATED_INFO_ERROR });
    sendErrorMsg(error);
  }
};
